module.exports = __webpack_public_path__ + "static/media/unsplash_xttrPiu_pjw.8ecf79f4.jpg";